<nz-card class="round-border p-4" [nzLoading]="!loaded">
	<a [routerLink]="['/module-qcm']">
		<nz-statistic
			[nzValue]="count | number"
			[nzTitle]="'module-qcm_common_name' | translate"
		></nz-statistic>
	</a>
</nz-card>
